import AuthAPI from '@/apis/business/account/auth-student-api.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  getters: {},
  actions: {
    /**
     * Đổi mật khẩu
     * @param {*} context
     * @param {*} params
     * @returns
     */
    changePassword (context, params) {
      return AuthAPI.postAsync('password/change', params)
    }
  }
}
